//CONSTANTES HOME
export const GET_MODULES = 'GET_MODULES'; 
export const MODULES_SUCCESS = 'MODULES_SUCCESS'; 

export default { GET_MODULES, MODULES_SUCCESS }